// extracted by mini-css-extract-plugin
module.exports = {"letterTitle":"IndexList_letterTitle____KHA","drugLink":"IndexList_drugLink__2Bvz6","italics":"IndexList_italics__U41kX"};